import React from 'react';
import { Building2 } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { useNavigate } from 'react-router-dom';
import { FacilityTable } from './FacilitiesTable';

export const FacilityLibrarySection = {
	settingsView: 'facilities',
	title: 'Facilities',
	description: 'Manage hospitals, SNFs, and other facilities',
	TitleIcon: Building2
} satisfies SettingsSectionItem;

export function FacilityLibrary() {
	const navigate = useNavigate();
	const handleAdd = () => {
		navigate('add');
	};

	return (
		<LibrarySection
			librarySection={FacilityLibrarySection}
			handleAdd={handleAdd}
			addLabel="Add Facility"
			searchPlaceholder="Search facilities by name, city, or address..."
			noResultsLabel="No Facilities Found"
			noResultsSubLabel="Get started by adding your first facilty"
			TableComponent={FacilityTable}
		/>
	);
}
